import { useNavigate } from 'react-router-dom';
import { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios/index";
import DateFunc from '@/lib/lyg/date_func';
import strFunc from '@/lib/lyg/string';
import SearchArea from "./area/search";
import ListArea from "./area/list";
import Paging from "@/pcomponents/common/crud/list/paging/paging";
import CoolenMoveUrl from "@/pcomponents/common/content/coolen/study/func/move_url";

function WordInsideUseListArea(props: any) {
  let myProps = {
    ...props
  };
  const navigate = useNavigate();
  let user = useSelector((state: any) => state.user);
  const [listOpt, setListOpt] = useState({
    'now_page': 1,
    'num_per_page': 30,
    'order_id': 'a_re_start_date DESC,a_update_date DESC',
    'order_type': '',
    's_date_type': '',
    's_start_date': '',
    's_end_date': '',

    s_stu_mcomp_seq: "",
    s_stu_seq: "",
    s_title_like: "",
    s_word_type: "",
    s_addon_inside: "1",
    s_addon_study_word: "1",
  });
  const [infoArr, setInfoArr] = useState<any>([]);
  const [countInfo, setCountInfo] = useState({ "tot": 0 });
  const [is_able_period, set_is_able_period] = useState(false);
  const [textbook_use_info, set_textbook_use_info] = useState<any>(null);//word_inside_textbook_use_info
  const [able_period_day_cnt, set_able_period_day_cnt] = useState(0);

  useEffect(() => {
    list({});
    get_word_inside_textbook_use_info_by_ajax();
  }, [user.comp_seq]);

  const list = (inOptObj: any) => {
    let tmp_listOpt: any = {
      ...listOpt,
      ...inOptObj
    };
    setListOpt(tmp_listOpt);
    tmp_listOpt.s_stu_mcomp_seq = user.comp_seq;
    tmp_listOpt.s_stu_seq = user.user_seq;
    if (strFunc.is_empty(tmp_listOpt.s_stu_mcomp_seq)) {
      return false;
    }
    if (strFunc.is_empty(tmp_listOpt.s_stu_seq)) {
      return false;
    }

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/word/word_inside_use/list', tmp_listOpt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          setInfoArr(response.data["data"]["info_arr"]);
          setCountInfo(response.data["data"]["count_info"]);
        } else {

        }
      });
  };

  const get_word_inside_textbook_use_info_by_ajax = () => {
    let form_json_data: any = {
      s_stu_mcomp_seq: user.comp_seq,
      s_stu_seq: user.user_seq,
      //s_in_now_period: "1",
      s_use_sort: "word_inside",
      s_addon_textbook: "1",
      is_paging: "",
    };

    if (strFunc.is_empty(form_json_data.s_stu_mcomp_seq)) {
      return false;
    }
    if (strFunc.is_empty(form_json_data.s_stu_seq)) {
      return false;
    }

    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/textbook/use/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data["data"]["info_arr"].length > 0) {
            let tmp_use_info = response.data["data"]["info_arr"][0];
            set_textbook_use_info(tmp_use_info);
            let tmp_now_date_str = DateFunc.get_date_format(new Date(), "Y-m-d");
            if (tmp_use_info["a_period_end_date"] >= tmp_now_date_str) {
              set_is_able_period(true);
              set_able_period_day_cnt(DateFunc.get_diff_days_of_date(new Date(tmp_now_date_str), new Date(tmp_use_info["a_period_end_date"])));
            }
          }
        } else {

        }
      });
  };

  const go_start_study = (inData: any) => {
    let opt_obj = {
      info: null,
      ...inData
    };

    if (is_able_period == false) {
      alert("이용가능 기간이 만료되었습니다.");
      return false;
    }

    let info = opt_obj.info;
    let row_title_str="";
    if(info.inside_info){
      row_title_str=info.inside_info["a_title"];
    }
    let cool_move_opt: any = {
      coolen_study_par_id: "word_inside",
      coolen_study_par_seq: info["a_in_seq"],
      coolen_study_sort: "word_school",
      study_is_save: "1",
      back_sort: "web_student",
      title:row_title_str,
    };
    if (info.inside_info["a_word_type"] == "stc") {
      cool_move_opt.coolen_study_sort = "word_school2";
    }
    CoolenMoveUrl.go_to_url(cool_move_opt);
  };

  return (
    <div style={{ width: "98%", margin: "0 auto", padding: "5px" }}>
      <div className="text-right mt-1" style={{ position: "relative",lineHeight:"32px",height:"32px" }}>
        <span style={{ position: "absolute", left: 0 }}>
          브릿지영어 단어학습
          {is_able_period &&
            <span className='ml-1' style={{ color: "gray" }}>
              (<span style={{ color: "blue" }}>{able_period_day_cnt}</span>일 남음)
            </span>
          }
          {is_able_period == false &&
            <span className='ml-1' style={{ color: "gray" }} >(이용기간만료됨)</span>
          }
        </span>
        {is_able_period &&
          <button
            className="btn btn-sky"
            onClick={() => {
              navigate("/comp_stu/plan/word_inside/req_list");
            }}>모든학습보기</button>
        }
      </div>
      <div className='mt-2'>
        <SearchArea
          list={list}
          listOpt={listOpt}
        ></SearchArea>
      </div>
      <div className='mt-1'>
        <ListArea
          infoArr={infoArr}
          go_start_study={go_start_study}
        ></ListArea>
      </div>
      <div className='mt-1'>
        <Paging now_page={listOpt.now_page}
          num_per_page={listOpt.num_per_page}
          total_rec={countInfo.tot}
          is_view_num_per_page={true}
          onChangePage={(now_page: number) => { list({ now_page: now_page }); }}
          onChangeNumPerPage={(num_per_page: number) => { list({ now_page: 1, num_per_page: num_per_page }); }}></Paging>
      </div>
    </div>
  );
};
export default WordInsideUseListArea;